const MESSAGES = {
  'zh-TW': {
    langZh: '繁中',
    langEn: 'EN',
    claimTitle: '優惠券領取',
    walletTitle: '我的優惠券',
    couponsTitle: '我的優惠券',
    stepForm: '選擇方式',
    stepVerify: 'Email 驗證',
    stepSuccess: '領取成功',
    claimNow: '領取優惠券',
    loading: '載入中…',
    emailClaim: 'Email 領取',
    phoneLabel: '手機號碼',
    phonePlaceholder: '912345678',
    emailLabel: 'Email',
    emailPlaceholder: 'your@email.com',
    sendCode: '寄送驗證碼',
    sending: '寄送中…',
    sendCodeCooldown: '寄送驗證碼（{{sec}}s）',
    orDivider: '或',
    lineLogin: '使用 LINE 登入領取',
    lineOpenInApp: '在 LINE 中領取',
    lineAutoClaim: '正在為您領取優惠券…',
    lineResolvingSub: '正在取得 LINE 身分…',
    lineErrorCode: '錯誤代碼：{{code}}',
    lineLoginRedirect: '請在 LINE 完成登入…',
    lineGoRegister: '尚未綁定會員，請先完成綁定',
    lineRetryClaim: '再試一次領取',
    lineBindMember: '前往綁定會員',
    backToMemberCard: '返回會員卡',
    lineBusy: 'LINE 驗證中…',
    verifySent: '驗證碼已寄至',
    otpLabel: '驗證碼',
    otpPlaceholder: '000000',
    confirmClaim: '確認領取',
    claiming: '領取中…',
    resend: '重新寄送驗證碼',
    resendCooldown: '重新寄送（{{sec}}s）',
    refill: '重新填寫',
    redeemCode: '兌換編號',
    qrNote: '請到櫃台出示 QR，由櫃檯掃描後確認兌換；或口頭報 6 碼兌換編號',
    viewCoupons: '查看我的優惠券',
    goCard: '前往會員卡',
    bindCard: '綁定會員卡',
    expireLabel: '到期',
    statusUnused: '未兌換',
    statusUsed: '已兌換',
    statusExpired: '已過期',
    walletUsedNote: '此券已兌換，無需再次出示',
    walletExpiredNote: '此券已過期',
    tabUnused: '未使用',
    tabUsed: '已使用',
    tabExpired: '已過期',
    tabAll: '全部',
    emptyCoupons: '目前沒有優惠券',
    loginRequired: '請先登入再查看優惠券',
    showQr: '出示 QR',
    claimSuccess: '領取 {{name}} 成功',
    NO_CODE: '連結不完整，請確認優惠券連結包含 code 參數，或重新向店家索取連結。',
    NOT_FOUND: '找不到此代碼',
    INACTIVE: '此活動未啟用',
    OUT_OF_WINDOW: '不在可領取期間',
    SOLD_OUT: '已達總量上限',
    ALREADY_USED: '你已使用過此券',
    ALREADY_CLAIMED: '你已領取過此券',
    BAD_PHONE: '請輸入正確的手機號碼',
    BAD_EMAIL: '請輸入正確的 Email',
    BAD_OTP: '請輸入驗證碼',
    OTP_EXPIRED: '驗證碼已過期，請重新寄送',
    INVALID_SESSION: '驗證逾時，請重新寄送驗證碼',
    SESSION_MISMATCH: '驗證資料不符，請重新開始',
    PHONE_ALREADY_CLAIMED: '此手機已領取過本優惠券',
    EMAIL_ALREADY_CLAIMED: '此 Email 已領取過本優惠券，請使用其他信箱',
    EMAIL_RATE_LIMIT: '寄送太頻繁，請稍後再試',
    MAIL_FAILED: '寄信失敗，請稍後再試',
    DB_NOT_READY: '系統設定中，請稍後再試或改用 LINE 領取',
    SERVER_ERROR: '系統暫時無法處理，請稍後再試',
    LINE_MEMBER_NOT_FOUND: '尚未綁定會員，正在前往註冊…',
    walletMissing: '缺少優惠券資訊',
    walletNotFound: '找不到此優惠券',
    walletLoadFail: '載入失敗',
    rateLimit: '寄送太頻繁，請 {{sec}} 秒後再試',
    lineVerify: '正在透過 LINE 驗證…',
    lineClaiming: 'LINE 驗證成功，正在領取…',
    lineNoSub: '未取得 LINE 身分，請再試一次或使用 Email 領取',
    lineFail: 'LINE 領券失敗',
    INVALID_ID_TOKEN: 'LINE 登入驗證失敗，請關閉後重新從 LINE 開啟連結',
    lineFailRetry: 'LINE 領券暫時失敗，請再按一次或使用 Email 領取',
    lineRetryHint: '若已完成 LINE 登入仍停住，請再按一次',
    enterPhone: '請輸入正確的手機號碼',
    enterEmail: '請輸入正確的 Email',
    enterOtp: '請輸入 Email 驗證碼',
    sendFail: '寄送失敗',
    claimFail: '領取失敗',
    loadFail: '載入優惠券資訊失敗',
    otpSent: '驗證碼已寄至 {{email}}',
    processing: '處理中…',
  },
  en: {
    langZh: '繁中',
    langEn: 'EN',
    claimTitle: 'Claim coupon',
    walletTitle: 'My coupon',
    couponsTitle: 'My coupons',
    stepForm: 'Your details',
    stepVerify: 'Email verify',
    stepSuccess: 'Claimed',
    claimNow: 'Claim coupon',
    loading: 'Loading…',
    emailClaim: 'Claim via Email',
    phoneLabel: 'Mobile',
    phonePlaceholder: '912345678',
    emailLabel: 'Email',
    emailPlaceholder: 'your@email.com',
    sendCode: 'Send code',
    sending: 'Sending…',
    sendCodeCooldown: 'Send code ({{sec}}s)',
    orDivider: 'or',
    lineLogin: 'Claim with LINE',
    lineOpenInApp: 'Claim in LINE',
    lineAutoClaim: 'Claiming your coupon…',
    lineResolvingSub: 'Getting LINE identity…',
    lineErrorCode: 'Error code: {{code}}',
    lineLoginRedirect: 'Please finish signing in on LINE…',
    lineGoRegister: 'Link your membership first',
    lineRetryClaim: 'Try claiming again',
    lineBindMember: 'Link membership',
    backToMemberCard: 'Back to member card',
    lineBusy: 'Verifying LINE…',
    verifySent: 'Code sent to',
    otpLabel: 'Verification code',
    otpPlaceholder: '000000',
    confirmClaim: 'Confirm claim',
    claiming: 'Claiming…',
    resend: 'Resend code',
    resendCooldown: 'Resend ({{sec}}s)',
    refill: 'Start over',
    redeemCode: 'Redemption code',
    qrNote: 'Show this QR at the counter for staff to scan and redeem.',
    viewCoupons: 'View my coupons',
    goCard: 'Go to member card',
    bindCard: 'Link member card',
    expireLabel: 'Valid until',
    statusUnused: 'Unused',
    statusUsed: 'Redeemed',
    statusExpired: 'Expired',
    walletUsedNote: 'This coupon has been redeemed.',
    walletExpiredNote: 'This coupon has expired.',
    tabUnused: 'Unused',
    tabUsed: 'Used',
    tabExpired: 'Expired',
    tabAll: 'All',
    emptyCoupons: 'No coupons yet',
    loginRequired: 'Please log in to view coupons',
    showQr: 'Show QR',
    claimSuccess: 'Claimed {{name}} successfully',
    NO_CODE: 'Invalid link. Please open the full coupon link from the store.',
    NOT_FOUND: 'Code not found',
    INACTIVE: 'This offer is inactive',
    OUT_OF_WINDOW: 'Outside claim period',
    SOLD_OUT: 'All coupons have been claimed',
    ALREADY_USED: 'You have already used this coupon',
    ALREADY_CLAIMED: 'You have already claimed this coupon',
    BAD_PHONE: 'Please enter a valid mobile number',
    BAD_EMAIL: 'Please enter a valid email',
    BAD_OTP: 'Please enter the verification code',
    OTP_EXPIRED: 'Code expired. Please request a new one.',
    INVALID_SESSION: 'Session expired. Please request a new code.',
    SESSION_MISMATCH: 'Verification mismatch. Please start again.',
    PHONE_ALREADY_CLAIMED: 'This mobile has already claimed this coupon',
    EMAIL_ALREADY_CLAIMED: 'This email has already claimed this coupon',
    EMAIL_RATE_LIMIT: 'Too many requests. Please try again later.',
    MAIL_FAILED: 'Failed to send email. Please try again.',
    DB_NOT_READY: 'System setup in progress. Try LINE claim or try again later.',
    SERVER_ERROR: 'Server error. Please try again later.',
    LINE_MEMBER_NOT_FOUND: 'Member not linked. Redirecting to registration…',
    walletMissing: 'Missing coupon information',
    walletNotFound: 'Coupon not found',
    walletLoadFail: 'Failed to load',
    rateLimit: 'Too many requests. Try again in {{sec}} seconds.',
    lineVerify: 'Verifying with LINE…',
    lineClaiming: 'LINE verified. Claiming…',
    lineNoSub: 'LINE identity not found. Try again or use Email.',
    lineFail: 'LINE claim failed',
    INVALID_ID_TOKEN: 'LINE sign-in failed. Close and reopen the link in LINE.',
    lineFailRetry: 'LINE claim failed. Tap again or use Email.',
    lineRetryHint: 'If LINE login finished but this is stuck, tap again.',
    enterPhone: 'Please enter a valid mobile number',
    enterEmail: 'Please enter a valid email',
    enterOtp: 'Please enter the verification code',
    sendFail: 'Failed to send',
    claimFail: 'Claim failed',
    loadFail: 'Failed to load coupon',
    otpSent: 'Code sent to {{email}}',
    processing: 'Processing…',
  },
};

export const COUPON_LANG_KEY = 'coupon:lang';

export function normalizeCouponLang(raw) {
  const s = String(raw || '').trim().toLowerCase();
  if (s === 'en' || s.startsWith('en-')) return 'en';
  return 'zh-TW';
}

export function getStoredCouponLang() {
  try {
    return normalizeCouponLang(localStorage.getItem(COUPON_LANG_KEY));
  } catch {
    return 'zh-TW';
  }
}

export function storeCouponLang(lang) {
  try {
    localStorage.setItem(COUPON_LANG_KEY, normalizeCouponLang(lang));
  } catch { /* ignore */ }
}

export function getCouponT(lang, key, vars = {}) {
  const L = MESSAGES[normalizeCouponLang(lang)] || MESSAGES['zh-TW'];
  let text = L[key] || MESSAGES['zh-TW'][key] || key;
  Object.entries(vars).forEach(([k, v]) => {
    text = text.replace(new RegExp(`\\{\\{${k}\\}\\}`, 'g'), String(v ?? ''));
  });
  return text;
}
